export const holidayEntryDurationOptions = [
  { value: 480, label: "allDay" },
  { value: 240, label: "halfDay" },
];
